
/**!
 *  Loading spinner.
 *
 *  @prop string className - Append a class name.
 *  @prop integer size - Size in pixels.
 *  @prop boolean overlay - Whether the spinner should be centered on top of its container.
 *
 *  Author: Bjorn Tollstrom <bjorn@rodolfo.se>
 */

import React from "react";
import PropTypes from "prop-types";
import "./spinner.scss";

import Icon from "Components/Layout/Icon";

class Spinner extends React.Component
{
    constructor(props)
    {
        super(props);
        this.Mounted = false;
        this.Timeout = null;
        this.state = {showMessage: false}
    }

    componentDidMount()
    {
        const {message} = this.props;
        this.Mounted = true;
        if (message)
        {
            this.ResetTimeout();
        }
    }

    componentDidUpdate = (prevProps) =>
    {
        const {message: m1} = this.props;
        const {message: m2} = prevProps;
        if (!m2 && m1)
        {
            this.ResetTimeout();
        }
    }

    componentWillUnmount()
    {
        this.Mounted = false;
        this.ClearTimeout();
    }

    ClearTimeout = () =>
    {
        clearTimeout(this.Timeout);
    }

    ResetTimeout = () =>
    {
        const {showMessageAfter} = this.props;
        this.ClearTimeout();
        this.Timeout = setTimeout(() => this.setState({showMessage: true}), showMessageAfter * 1000);
    }

    render()
    {
        const CA = ["SpinnerContainer"];
        const {className, message, overlay, size} = this.props;
        const {showMessage} = this.state;

        if (className)
        {
            CA.push(className);
        }
        if (overlay)
        {
            CA.push("Absolute");
        }
        else
        {
            CA.push("Relative");
        }
        if (showMessage)
        {
            CA.push("ShowMessage");
        }

        return (
            <div className={CA.join(" ")}>
                <div className="Spinner" style={{width: size, height: size}}>
                    <div className="SpinnerIconWrapper">
                        <Icon
                            className="SpinnerIcon"
                            feather="Loader"
                            size={size}
                        />
                    </div>
                    {showMessage && (
                        <div className="SpinnerMessage">
                            {message}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

Spinner.propTypes =
{
    className: PropTypes.string,
    message: PropTypes.string,
    overlay: PropTypes.bool,
    showMessageAfter: PropTypes.number,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Spinner.defaultProps =
{
    className: "",
    message: "",
    overlay: false,
    showMessageAfter: 2,
    size: 60
}

export default Spinner;